window.addEventListener("DOMContentLoaded", () => {
  const passwordToggles = document.querySelectorAll('.password__toggle');

  for(const toggle of passwordToggles) {
    toggle.addEventListener('click', (e) => {
      const input = e.target.previousElementSibling;
      const type = input.getAttribute('type');
      input.setAttribute('type', type === 'password' ? 'text' : 'password');
      toggle.classList.toggle('is-visible');
    })
  }
})